<template>
  <div class='text-center'>
    <v-btn
      @mouseover='hasMouseOver = true'
      @mouseleave='hasMouseOver = false'
      x-small
      outlined
      :color='buttonColor'
      @click='openAddRoute'
      dark
    >
      Create New Route
    </v-btn>
    <route-details-dialog
      :showDialog='showAddDialog'
      @update='createRoute'
      @cancel='showAddDialog = false'
      :date='date'
    ></route-details-dialog>

  </div>
</template>

<script>
import RouteDetailsDialog from './RouteDetailsDialog';

export default {
  name: 'add-route-button',
  props: {
    date: {
      required: true
    },
    schedule: {
      required: true
    }
  },
  data: () => ({
    hasMouseOver: false,
    isLoading: false,
    showAddDialog: false
  }),
  computed: {
    buttonColor () {
      return this.hasMouseOver ? 'info' : 'grey lighten-1';
    },
    leads () {
      return this.staff.filter(s => s.can_be_lead === true);
    }
  },
  methods: {
    openAddRoute () {
        this.showAddDialog = true;
    },
    async createRoute (route) {
      this.$emit('addRoute', route);
      this.showAddDialog = false;
    }
  },
  components: {
    'route-details-dialog': RouteDetailsDialog
  }
}
</script>
